import { render } from "./RecommendedProduct.vue?vue&type=template&id=e11da9a0&scoped=true"
import script from "./RecommendedProduct.vue?vue&type=script&lang=js"
export * from "./RecommendedProduct.vue?vue&type=script&lang=js"

import "./RecommendedProduct.vue?vue&type=style&index=0&id=e11da9a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e11da9a0"]])

export default __exports__